import React from "react";

import OptionsTablePair from "../OptionsTable/Pair";
import PubKeyPicker from "../FormComponents/PubKeyPicker";

export default function AccountMerge(props) {
  return [
    <OptionsTablePair label="Destination" key="destination">
      <PubKeyPicker
        value={props.values["destination"]}
        onUpdate={(value) => {
          props.onUpdate("destination", value);
        }}
      />
    </OptionsTablePair>,
  ];
}
